export const init = () => {
  if (tc_vars.env_template !== 'product') return;

  const fwk = CUBE.Analytics;

  /*
   * STEPS NAMES (order_checkout_step)
   * 	+ Associated LOCKS (avoid mutiple sending)
   */
  const stepLogin = 'LOGIN_STEP_2';
  let lockLogin = false;

  const stepMissingInformations = 'MISSINGINFORMATIONS_STEP_0';
  let lockMissingInformations = false;

  const stepExpress = 'EXPRESS_STEP_1';
  let lockExpress = false;

  const stepShipping = 'SHIPPING_STEP_3';
  let lockShipping = false;

  const stepPayment = 'PAYMENT_STEP_4';
  let lockPayment = false;

  /**
   * ENHANCED E-COMMERCE for EXPRESS CHECKOUT
   *
   * 	Starts at 'Add To Cart' (previous actions are handled in a classical way)
   */

  // > ADD TO CART
  // Triggered by 'Express Payment' button (conversion area)
  const eventAddToCartExpress = fwk.utils.getEvent(
    'expressCheckout',
    AnalyticsConstants.trackers.funnel.express.name
  );
  if (eventAddToCartExpress) {
    eventAddToCartExpress.postAction(() => {
      if (CUBE.Analytics.utils.productpage.isSizeSelected()) {
        const model = fwk.utils.productpage.getModel();
        fwk.enhanced.sendAddToCart(model);
      }
    });
  }

  // > LOGIN (Virtual Page)
  const eventLoginExpress = fwk.utils.getEvent(
    'expressCheckoutVirtualLogin',
    AnalyticsConstants.trackers.funnel.express.name
  );
  if (eventLoginExpress) {
    eventLoginExpress.stopEvent = function() {
      if (this.triggerVirtual) this.triggerVirtual();
      return true;
    };
    eventLoginExpress.triggerVirtual = () => {
      if (!lockLogin) triggerVirtualPage(stepLogin);
      lockLogin = true;
    };
  }
  // > MISSING INFORMATION ON LOGIN
  const eventMissingInformationExpress = fwk.utils.getEvent(
    'expressCheckoutVirtualMissingInformation',
    AnalyticsConstants.trackers.funnel.express.name
  );
  if (eventMissingInformationExpress) {
    eventMissingInformationExpress.stopEvent = function() {
      if (this.triggerVirtual) this.triggerVirtual();
      return true;
    };
    eventMissingInformationExpress.triggerVirtual = () => {
      if (!lockMissingInformations) triggerVirtualPage(stepMissingInformations);
      lockMissingInformations = true;
    };
  }

  // > SUMMARY (Virtual Page)
  const eventSummaryExpress = fwk.utils.getEvent(
    'expressCheckoutVirtualSummary',
    AnalyticsConstants.trackers.funnel.express.name
  );
  if (eventSummaryExpress) {
    eventSummaryExpress.stopEvent = function() {
      if (this.triggerVirtual) this.triggerVirtual();
      return true;
    };
    eventSummaryExpress.triggerVirtual = () => {
      if (!lockExpress) triggerVirtualPage(stepExpress);
      lockExpress = true;
    };
  }

  // > SHIPPING METHOD (Virtual Page)
  const eventShippingtExpress = fwk.utils.getEvent(
    'expressCheckoutVirtualShipping',
    AnalyticsConstants.trackers.funnel.express.name
  );
  if (eventShippingtExpress) {
    eventShippingtExpress.stopEvent = function() {
      if (this.triggerVirtual) this.triggerVirtual();
      return true;
    };
    eventShippingtExpress.triggerVirtual = () => {
      if (!lockShipping) triggerVirtualPage(stepShipping);
      lockShipping = true;
    };
  }

  // > PAYMENT METHOD (Virtual Page)
  const eventPaymentExpress = fwk.utils.getEvent(
    'expressCheckoutVirtualPayment',
    AnalyticsConstants.trackers.funnel.express.name
  );
  if (eventPaymentExpress) {
    eventPaymentExpress.stopEvent = function() {
      if (this.triggerVirtual) this.triggerVirtual();
      return true;
    };
    eventPaymentExpress.triggerVirtual = () => {
      if (!lockPayment) triggerVirtualPage(stepPayment);
      lockPayment = true;
    };
  }

  /**
   * VIRTUAL PAGE METHOD
   */
  const triggerVirtualPage = name => {
    const frame = window.frames['virtual-page'];
    const urlPage = '/assets/virtual.html';

    frame.src = `${urlPage}?page=${name}`;
  };
};



// WEBPACK FOOTER //
// ./src/analytics/enhanced/ec-express-checkout.js